import { NgTemplateOutlet } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import dayjs from 'dayjs';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { Button, ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { Popover } from "primeng/popover";
import { TableModule } from 'primeng/table';
import { ProjectSubmenuComponent } from '../../../../../../project-submenu/project-submenu.component';
import { ProjectSecret, ProjectSecretService } from '../../../../../../shared/services/project-secret.service';
import { ProjectService } from '../../../../../../shared/services/project.service';
import { RouteShareService } from '../../../../../../shared/services/route-share.service';
import { SecretAddModalComponent } from './secret-add-modal/secret-add-modal.component';
import { SecretEditModalComponent } from './secret-edit-modal/secret-edit-modal.component';

@Component({
  imports: [NgTemplateOutlet, InputTextModule,
    IconFieldModule,
    InputIconModule,
    ConfirmPopupModule,
    TableModule,
    FormsModule,
    ButtonModule,
    ProjectSubmenuComponent,
    Popover,
    ConfirmDialogModule
  ],
  providers: [ConfirmationService],
  standalone: true,
  templateUrl: './project-secrets-tab.component.html',
  styleUrl: './project-secrets-tab.component.scss'
})
export class ProjectSecretsTabComponent implements OnInit {
  public dayjs = dayjs;
  public contextMenu: (MenuItem & { command: () => void })[] = [];
  private activePop: Popover | null = null;

  constructor(
    protected projectService: ProjectService,
    protected secretService: ProjectSecretService,
    protected rss: RouteShareService,
    private modalService: BsModalService,
    private confirmationService: ConfirmationService
  ) {
  }

  public ngOnInit(): void {
    if (this.projectService.selectedProject) {
      this.secretService.selectedProjectId = this.projectService.selectedProject._id;
    } else {
      this.secretService.selectedProjectId = "";
    }
  }

  public confirmationCheck(secretId: string) {
    this.confirmationService.confirm({
      header: $localize`:@@confirm-delete-header-secret:Secret löschen`,
      icon: 'ri-error-warning-line',
      message: $localize`:@@confirm-delete-message-secret:Möchtest du dieses Secret wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.`,
      rejectButtonProps: {
        label: $localize`:@@delete-reject:Abbrechen`,
        severity: 'secondary',
        outlined: true
      },
      acceptButtonProps: {
        label: $localize`:@@delete-accept:Löschen`,
        severity: 'danger'
      },
      accept: async () => {
        await this.secretService.deleteSecret(secretId);
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }

  protected openAddModal() {
    this.modalService.show(SecretAddModalComponent, {
      class: 'modal-lg',
      keyboard: false,
      ignoreBackdropClick: true,
      initialState: {

      }
    });
  }
  protected openEditModal(secret: ProjectSecret) {
    this.modalService.show(SecretEditModalComponent, {
      class: 'modal-lg',
      initialState: {
        name: secret.name,
        description: secret.description,
        secret: "",
        secretShouldBeUpdated: false,
        secretId: secret._id
      }
    });
  }
  public openMenu(event: MouseEvent, popover: Popover, secret: ProjectSecret, button: Button) {
    if (this.activePop && this.activePop !== popover) {
      this.activePop.hide();
    }
    this.contextMenu = this.getMenuItems(secret);
    popover.toggle(event, button.el.nativeElement);
    this.activePop = popover;
  }
  private getMenuItems(secret: ProjectSecret) {
    {
      const menu: (MenuItem & { command: () => void })[] = [];
      menu.push({
        label: $localize`:@@edit:Bearbeiten`,
        icon: 'ri ri-pencil-fill',
        command: () => {
          this.openEditModal(secret);
        }
      });
      menu.push({
        label: $localize`:@@delete:Löschen`,
        icon: 'ri ri-delete-bin-6-fill',
        command: () => {
          this.confirmationCheck(secret._id);
        }
      });
      return menu;
    }
  }
}
